{
  "__comment.error.app": "Erreurs générées dans l'app - weblate: copier-coller sans traduire cette ligne",
  "__comment.error.backend": "Erreurs générées depuis le backend - weblate: copier-coller sans traduire cette ligne",
  "admin.unauthorized": "Você não está autorizado a realizar esta ação",
  "anonymous.request": "Ocorreu um erro. Se o problema persistir, entre em contato conosco",
  "app-service.not-connected": "Você não parece estar conectado à Internet.",
  "app-service.unavailable.description": "Um problema de conexão está impedindo o acesso ao serviço. Por favor, verifique sua conexão de rede.",
  "app.accessibility.community": "Página comunidade",
  "app.accessibility.intentions": "Página de intenções",
  "app.accessibility.intentions-theme": "Página de intenções temáticas",
  "app.accessibility.messages": "Página de mensagens",
  "app.accessibility.unsubscribe-donation-mail": "Página de cancelamento dos emails de doação",
  "app.audio.listen": "Ouça o áudio",
  "app.audio.loading-error": "Ocorreu um erro ao carregar o arquivo de áudio",
  "app.avoidance-navigation.content": "Conteúdo da página",
  "app.banner.goal.goal": "Objetivo: {amount} doações regulares",
  "app.description": "Graças ao <strong>aplicativo Hozana</strong>, acesse com um clique o seu cantinho de oração, descubra novas comunidades e deixe suas intenções onde quer que você esteja!",
  "app.discover": "Descubra as nossas propostas",
  "app.donation.later.i-want": "Receba um lembrete",
  "app.donation.later.success.toast": "Você receberá um lembrete em alguns dias",
  "app.download": "Baixe o aplicativo",
  "app.error": "Oops, an error occurred, please try again later.",
  "app.how-to.open-menu": "Menu: para abrir o menu lateral, pressione Enter; para fechar o menu, pressione Esc",
  "app.i-donate": "Eu doo",
  "app.maintenance": "<strong>Hozana</strong> está em manutenção.\nAguarde alguns minutos antes de atualizar o navegador para continuar.",
  "app.navigation.events-link": "Os encontros Hozana!",
  "app.navigation.footer.faq.link": "Perguntas frequentes!",
  "app.navigation.footer.guide.all": "Todos os artigos em nossos guias",
  "app.navigation.footer.guide.bible": "Descubra a Bíblia",
  "app.navigation.footer.guide.catechism": "Catecismo: respostas às suas perguntas!",
  "app.navigation.footer.guide.feast-days": "As festas cristãs",
  "app.navigation.footer.guide.meditation": "Guia para Meditação Cristã",
  "app.navigation.footer.guide.miracles": "Descubra os milagres e aparições",
  "app.navigation.footer.guide.prayer": "Conselhos para orar",
  "app.navigation.footer.guide.rosary": "Guia para rezar o rosário",
  "app.navigation.footer.guide.saints": "Descubra os santos",
  "app.navigation.footer.who.we.are.link": "Quem somos nós?",
  "app.navigation.jobs-link": "Ofertas de emprego!",
  "app.navigation.main": "Menu principal",
  "app.navigation.open-menu": "Menu aberto",
  "app.navigation.secondary": "Menu secundário",
  "app.report-abuse.comment": "Denunciar este comentário",
  "app.report-abuse.comment.success": "Este comentário foi sinalizado, obrigado pela sua ajuda!",
  "app.report-abuse.intention": "Denuncie esta intenção",
  "app.report-abuse.intention.success": "A intenção foi reportada, obrigado pela ajuda!",
  "app.report-abuse.placeholder": "Estou denunciando este conteúdo porque…",
  "app.report-abuse.reason": "Diga-nos abaixo por que você deseja denunciar este conteúdo.",
  "app.report-abuse.report": "Denunciar abuso",
  "app.report-abuse.send": "Denunciar",
  "app.report-abuse.uplift": "Relate esta mensagem de apoio",
  "app.report-abuse.uplift.success": "Esta mensagem foi sinalizada, obrigado pela ajuda!",
  "app.report-issue.button": "Relatar um problema",
  "app.report-issue.thank-you": "Agradecemos ! Seu problema foi relatado",
  "auth.complete.choose-password": "Escolha uma senha<br/>para finalizar sua inscrição no Hozana",
  "auth.complete.not-my-email": "Este não é meu endereço de e-mail",
  "auth.login.email": "Entrar com email",
  "auth.login.login": "Login",
  "auth.login.welcome": "Ben-vindo",
  "auth.otp.code.accessibility-label": "Código de autenticação de seis dígitos",
  "auth.otp.code.description": "Enviámos um código temporário para: {email}",
  "auth.otp.code.resend": "Reenviar o código",
  "auth.otp.code.title": "Verifique o seu email",
  "auth.otp.login.title": "Qual é o seu endereço de email?",
  "auth.otp.signup.title": "Como se chama?",
  "auth.privacy.notice": "A Hozana é gratuita. Consulte os <link>termos e condições</link>. A Hozana nunca partilhará o seu endereço de email com terceiros sem o seu consentimento.",
  "auth.signup.signup": "Inscreva-se",
  "auth.social.apple": "Iniciar sessão com a Apple",
  "auth.social.apple.missing-identity-token": "O início de sessão com a Apple não devolveu um token de identidade",
  "auth.social.google": "Continuar com o Google",
  "auth.social.google.canceled": "O início de sessão com o Google foi cancelado",
  "auth.social.google.missing-authorization-code": "O início de sessão com o Google não devolveu um código de autorização",
  "birthdate.invalid": "A data de nascimento é inválida",
  "captcha.invalid": "O teste do detector do robô falhou, por favor, tente novamente",
  "captcha.missing": "Marque \"Eu não sou um robô\"",
  "captcha.required": "Por favor faça este pequeno teste de identificação",
  "comment.community.unknown": "Comunidade não encontrada",
  "comment.delete.delete": "Excluir",
  "comment.delete.fail.none": "O comentário não pôde ser excluído",
  "comment.delete.not.found": "Não foi possível localizar o comentário que você deseja excluir",
  "comment.form.empty": "Escreva um comentário para publicar",
  "comment.from": "Comentário por {contactName}",
  "comment.id.not-found": "Comentário não encontrado",
  "comment.not-found": "Comentário não encontrado",
  "comment.relative.time": "{prefix} {time}",
  "comment.relative.time.today": "Hoje às {time}",
  "comment.relative.time.week-day": "{weekday} às {time}",
  "comment.relative.time.yesterday": "Ontem às {time}",
  "comment.relative.week-day": "{weekday}",
  "comment.update.not.found": "O comentário que você deseja editar não foi localizado",
  "comment.write.your-comment": "Seu comentário",
  "common.error.api.default": "Problema de conexão do servidor",
  "common.error.unknown": "Ocorreu um erro",
  "common.form.error.captcha.invalid": "O captcha não é válido. Por favor, tente novamente.",
  "common.form.error.captcha.required": "Por favor, selecione \"Eu não sou um robô\"",
  "common.form.error.email.invalid": "E-mail inválido",
  "common.form.error.fail": "Erro desconhecido, por favor, tente novamente",
  "common.form.error.field.invalid": "Campo inválido, por favor corrija",
  "common.form.error.field.required": "Por favor preencha este campo",
  "common.form.error.message.required": "Mensagem obrigatória",
  "common.form.error.password-is-name": "Sua senha deve ser diferente do seu nome",
  "common.form.error.password.different": "Por favor, confirme com a mesma senha",
  "common.form.error.subject.required": "Campo obrigatório",
  "common.word.start-today": "Comece hoje",
  "common.word.start-tomorrow": "Comece amanhã",
  "common.word.tomorrow": "Amanhã",
  "communities.categories": "Categorias",
  "communities.categories.all": "Todas as categorias",
  "communities.for-you.edit": "Modificar minhas preferências",
  "communities.for-you.empty": "Responda a algumas perguntas para que possamos lhe recomendar novenas, retiros ou comunidades permanentes segundo suas preferências.",
  "communities.for-you.settings": "Definir minhas preferências",
  "communities.other-suggestions": "Outras propostas do momento",
  "communities.search": "Sua pesquisa",
  "communities.see-more": "Ver mais comunidades",
  "community.activity.inactive": "Inativa",
  "community.all": "Ver todas as comunidades",
  "community.already-exists": "Já existe uma comunidade com esse nome",
  "community.close-for-today": "Encerrar por hoje",
  "community.communities.none-finished": "Você ainda não completou nenhuma novena, retiro ou comunidade",
  "community.communities.none-joined": "Você ainda não se inscreveu em nenhuma novena, retiro ou comunidade",
  "community.communities.suggested": "Sugerido para você",
  "community.communities.team-favorite": "❤️ Favoritos da equipe",
  "community.communities.view-all": "Ver todas as comunidades",
  "community.creation.suggestion": "Você pode criar e fornecer um percurso de oração : novena, retiro ou comunidade permanente.",
  "community.date.from-to": "de {fromDate} à {toDate}",
  "community.description.prayer.success": "Obrigado por sua oração!",
  "community.description.read-more": "Leia mais",
  "community.everlasting.unavailable-program": "Esta comunidade ainda não publicou nenhuma oração.",
  "community.join-mails.activation": "Ativar e-mails",
  "community.join-mails.subtitle": "Isso também servirá como um lembrete 😉",
  "community.join-mails.title": "Você gostaria de rezar {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidade}} do seu e-mail?",
  "community.join-next.everlasting.start": "Uma oração foi publicada hoje na comunidade. Gostaria de rezá-la?",
  "community.join-next.no-publication.start": "Enquanto aguarda {lifetime, select, novena {o início da novena} retreat {o início do retiro} other {uma primeira oração}}, você pode…",
  "community.join-next.pray-now": "Rezar agora",
  "community.join-next.start": "Você gostaria de começar {lifetime, select, novena {a novena} other {o retiro}} agora mesmo?",
  "community.join-next.start-later": "Começar mais tarde",
  "community.join.already-joined": "Você já está matriculado nesta data para este curso",
  "community.join.card.button": "Juntar-se {lifetime, select, retreat {ao retiro} novena {à novena} other {a esta comunidade}} em andamento",
  "community.join.confirmation.in-progress": "Você se inscreveu {lifetime, select, novena {na novena} other {no retiro}} <strong>em andamento</strong>.",
  "community.join.confirmation.soon": "Você começará {lifetime, select, retreat {o retiro} novena {a novena} other {a comunidade}} em {date}{rescheduled, select, true {.} other {, <strong>em {nbDays} {nbDays, plural, one {dia} other {dias}}</strong>.}}",
  "community.join.confirmation.today": "Você começa {lifetime, select, retreat {o retiro} novena {a novena} other {a comunidade}} <strong>hoje.</strong>",
  "community.join.congrats": "Bravo {userName}! Você está inscrito(a) na comunidade",
  "community.join.congrats.comingSoon": "Bravo {userName}! Você começará {lifetime, select, novena {a novena} other {o retiro}} em {date}",
  "community.join.congrats.ongoing": "Bravo {userName}! Você está se juntando {lifetime, select, novena {à novena} other {ao retiro}} a partir de hoje",
  "community.join.congrats.startToday": "Bravo {userName}! Você começa {lifetime, select, novena {a novena} other {o retiro}} hoje",
  "community.join.date": "Comece {lifetime, select, retreat {o retiro} novena {a novena} other {a comunidade}} na data que lhe convier",
  "community.join.date.validate": "Confirmo esta data",
  "community.join.error.no-subscription": "Ops! Parece haver um problema com a data de subscrição.",
  "community.join.from-date": "(a partir do dia {diffDays})",
  "community.join.infos": "Junte-se aos {nbMembers} usuários que estão rezando {lifetime, select, retreat {o retiro} novena {a novena} other {esta comunidade}} neste momento",
  "community.join.invalid-schedule-date": "A data escolhida não é válida",
  "community.join.not-schedulable": "Você não pode escolher uma data para esta comunidade",
  "community.join.options.title": "Quando você quer começar {lifetime, select, retreat {esse retiro} novena {essa novena} other {essa comunidade}} ?",
  "community.join.scheduled-end-date.novena": "A novena vai terminar na {date}",
  "community.join.scheduled-end-date.retreat": "O retiro terminará em {data}",
  "community.join.success.message": "Você se inscreveu {lifetime, select, retreat {no retiro} novena {na novena} other {na comunidade}}.",
  "community.leave-community": "Sair da comunidade",
  "community.leave-everlasting-community": "Não receber mais orações",
  "community.leave.already.left": "Você saiu desta comunidade",
  "community.leave.confirm": "Você realmente quer {lifetime, select, novena {parar esta novena?} retreat {parar este retiro?} other {sair desta comunidade?}}",
  "community.leave.fail": "Ocorreu um erro, por favor, tente novamente",
  "community.leave.success": "Você deixou {lifetime, select, novena {a novena} retreat {o retiro} other {a comunidade}}",
  "community.load.error": "Ocorreu um erro ao carregar a comunidade",
  "community.not-found": "Esta comunidade não existe",
  "community.not-joined": "Você não é ou não é mais membro desta comunidade.",
  "community.notifications.activate-push": "Ativar notificações",
  "community.notifications.receive-publications-push": "Você deseja receber uma notificação {lifetime, select, novena {para cada dia desta novena} retreat {para cada dia deste retiro} other {para cada oração desta comunidade}} ?",
  "community.notifications.receive-publications-push.subtitle": "Enviaremos uma notificação {lifetime, select, novena {todos os dias desta novena} retreat {todos os dias deste retiro} other {para cada oração desta comunidade}}",
  "community.private.private": "Privada",
  "community.publication.error.publication.not-accessible": "A publicação \"<strong>{publicationName}</strong>\" não é acessível para o momento.",
  "community.role.administrator.long": "Você é um administrador",
  "community.role.animator.long": "Você é um animador",
  "community.role.creator.long": "Você é o criador",
  "community.share.text": "Talvez alguém ao seu redor possa se interessar. Peça ao Espírito Santo que o ilumine 😇",
  "community.status.check.validating": "Aprovação pendente",
  "community.status.draft.word": "Rascunhos",
  "community.tab.description": "Descrição",
  "community.toolbar.community": "Ver {lifetime, select, retreat {o retiro} novena {a novena} other {a comunidade}}",
  "community.toolbar.stop": "Parar {lifetime, select, retreat {o retiro} novena {a novena} other {a comunidade}}",
  "community.toolbar.title": "Espaço do animador",
  "community.unavailable-program": "O programa {lifetime, select, retreat {desta novena} other {deste retiro}} ainda não está disponível.",
  "community.unmodifiable": "Você não pode editar esta comunidade",
  "community.virtus.publications.empty": "Seu conteúdo será exibido aqui",
  "communityAnnouncement.community.user.not-allowed": "Você não está autorizado a enviar um anúncio a membros desta comunidade",
  "communityAnnouncement.message.too-long": "Oh! O assunto do seu anúncio é muito longo",
  "communityAnnouncement.subject.too-long": "Oh! O assunto do seu anúncio é muito longo",
  "contact.captcha_v2.title": "Por favor, valide que você é um humano",
  "contact.email.invalid": "Insira um endereço de e-mail válido",
  "contact.firstname.invalid": "Por favor, digite seu primeiro nome",
  "contact.firstname.placeholder": "Nome",
  "contact.firstname.tooLong": "O primeiro nome não pode exceder 30 caracteres",
  "contact.lastname.invalid": "Por favor, digite seu sobrenome",
  "contact.lastname.label": "Seu sobrenome",
  "contact.lastname.placeholder": "Sobrenome",
  "contact.load.error": "Ocorreu um erro ao procurar seu correspondente.",
  "contact.message.alert": "Se você relatar um problema encontrado no site ou no aplicativo, detalhe-o com a maior precisão possível nos campos abaixo:",
  "contact.message.invalid": "Por favor, insira uma mensagem",
  "contact.message.label": "Conteúdo da sua mensagem",
  "contact.message.tooShort": "A mensagem deve conter pelo menos 100 caracteres",
  "contact.send-message": "Enviar uma mensagem",
  "contact.subject.invalid": "Por favor, insira o assunto da sua mensagem",
  "contact.subject.label": "Assunto da sua mensagem",
  "contact.subject.placeholder": "Assunto",
  "contact.subtitle": "Teremos o maior prazer em responder 😊",
  "contact.success.toast": "Sua mensagem foi enviada. Você entrará em contato com você o mais breve possível!",
  "content.forbidden-content": "Este conteúdo é inválido",
  "content.invalid": "O conteúdo não é válido",
  "content.invalid-contain-email": "Sua intenção não deve conter um e-mail",
  "content.invalid-contain-url": "Sua intenção não deve conter um link",
  "content.required": "Você precisa escrever um comentário antes de publicar",
  "content.too-long": "Este conteúdo é muito longo. Por favor, use apenas letras ou números",
  "content.too-short": "Este conteúdo é muito curto. Por favor, use apenas letras ou números",
  "conversation.ambiguous-definition": "Ops, surgiu um pequeno problema. Se o problema persistir, entre em contato conosco",
  "conversation.block": "Bloquear a conversa",
  "conversation.few-seconds": "Agora mesmo",
  "conversation.mark-as-unread": "Marcar como não lido",
  "conversation.not-found": "Esta conversa não existe",
  "conversation.unblock": "Desbloquear conversa",
  "conversation.user.not-allowed": "Oh ! Você não tem acesso a esta conversa. Tem certeza de ter se conectado com a conta correta?",
  "conversation.you-blocked": "Você bloqueou a conversa",
  "conversations.unread": "Não lidas",
  "cta.share": "Compartilhar",
  "dates.invalid": "As datas não são válidas",
  "day.count": "Dia {number}",
  "description.forbidden-content": "A descrição não é válida",
  "description.invalid": "Falta a descrição",
  "description.required": "A descrição não foi preenchida",
  "description.too-long": "A descrição é muito longa",
  "description.too-short": "A descrição é muito curta",
  "device.delete.not.found": "O dispositivo que você deseja remover não foi encontrado",
  "discover.see-more": "Veja mais conteúdo",
  "draft.conflict": "Esta publicação não pode ser salva como rascunho.",
  "email.already-exists": "Este e-mail já existe",
  "email.invalid": "O endereço de e-mail não é válido",
  "email.user.not-found": "Endereço de e-mail não encontrado",
  "error.403.title": "Você não tem acesso a esta página",
  "error.404.message": "Encontre comunidades que ajudarão você a orar",
  "error.404.quote": "\"Procurem a ajuda de Deus enquanto podem achá-lo,\norem ao Senhor enquanto ele está perto.\nIsaías\". 55:6",
  "error.404.title": "Desculpe, esta página não existe no Hozana…",
  "favorite.not-found": "Postagem favorita não encontrada",
  "file.not-an-image": "O arquivo enviado não é uma imagem. Apenas arquivos JPG / PNG / GIF são aceitos",
  "fraternity.gender.question": "Você é:",
  "fraternity.gender.title": "Para propor fraternidades não mistas",
  "fraternity.join.already-have": "Já tenho uma fraternidade",
  "fraternity.join.already-have-description": "Já sabe com quem vai viver o Virtus",
  "fraternity.join.find": "Encontrem-me uma fraternidade",
  "fraternity.join.find-description": "Colocá-lo-emos em contacto com outros participantes",
  "fraternity.join.subtitle": "As fraternidades Virtus são de um só sexo.",
  "fraternity.join.title": "Tem pessoas próximas com quem formar uma fraternidade?",
  "fraternity.lead.accept": "Aceito",
  "fraternity.lead.decline": "Prefiro não",
  "fraternity.lead.description": "Este papel consiste simplesmente em organizar e animar as reuniões de fraternidade. Não terá de carregar tudo nem ser um especialista espiritual.",
  "fraternity.lead.learn-more": "Saber mais sobre este papel",
  "fraternity.lead.title": "Você quer ser líder de fraternidade?",
  "fraternity.onboarding.close.body": "Se sair agora será inscrito no Virtus sem estar ligado a uma fraternidade.",
  "fraternity.onboarding.close.footer": "Poderá pedir para ser ligado a uma fraternidade a qualquer momento.",
  "fraternity.onboarding.close.title": "Quer realmente viver o Virtus sem fraternidade?",
  "fraternity.place.city-label": "Em que cidade vive?",
  "fraternity.place.hint": "Escolha encontros perto de si ou totalmente à distância.",
  "fraternity.place.nearby": "Perto de si",
  "fraternity.place.nearby-description": "Procurar participantes na sua região",
  "fraternity.place.remote": "À distância",
  "fraternity.place.remote-description": "Encontre a sua fraternidade onde estiver",
  "fraternity.place.title": "Onde deseja encontrar a sua fraternidade?",
  "fraternity.presentation.item.encourage": "Encorajem-se ao longo do percurso",
  "fraternity.presentation.item.pray": "Rezem uns pelos outros",
  "fraternity.presentation.item.share": "Partilhem cada semana o que vivem",
  "fraternity.presentation.subtitle": "O Virtus se vive numa fraternidade não mista de 8 pessoas.",
  "fraternity.presentation.title": "Viva a Quaresma em fraternidade",
  "fraternity.ready.eager-no": "Ainda hesito um pouco 😅",
  "fraternity.ready.eager-yes": "Sim, estou pronto(a) para viver esta Quaresma plenamente! 💪🏻",
  "fraternity.ready.subtitle": "O percurso Virtus é exigente. Está pronto(a) para se comprometer seriamente nesta Quaresma?",
  "fraternity.ready.title": "Bem-vindo(a) ao percurso Virtus!",
  "fraternity.recap.cta": "Procurar uma fraternidade",
  "fraternity.recap.lead": "Chefe de fraternidade",
  "fraternity.recap.place": "Local de fraternidade desejado",
  "fraternity.recap.sex": "Sexo",
  "fraternity.recap.subtitle": "Corrija se necessário antes de lançar a pesquisa.",
  "fraternity.recap.title": "Verifique as suas informações",
  "fraternity.step-label": "A sua fraternidade · {step} / 4",
  "fromDate.in-the-futur": "Opa! Você precisa escolher uma data futura como data de início",
  "fromDate.in-the-past": "Fino ! Você não pode escolher uma data anterior como data de início",
  "getCommunitiesJoined.user.not-found": "Não podemos encontrar comunidades",
  "getCommunitiesWithRole.user.not-found": "Não podemos encontrar comunidades",
  "getCommunityNotifications.subscriptionId.not-found": "Não foi possível carregar suas preferências de notificação para esta comunidade",
  "guestName.required": "Preencha seu nome",
  "guestName.too-long": "O primeiro nome é muito longo",
  "guide.not-found": "Os artigos neste guia não foram encontrados",
  "hash.invalid": "Ocorreu um erro: 'hash invalid'",
  "hash.required": "Ocorreu um erro: 'hash required'",
  "home.faq.title.head": "Como funciona?",
  "home.tagline": "Nossa oração salvará o mundo",
  "home.tagline.sub": "E isso vai mudar a sua vida!",
  "home.welcome.app-section.title": "Baixe o aplicativo Hozana",
  "home.welcome.intentions.title": "Deixe suas intenções,\nore por outras",
  "iframe.error.description": "Não foi possível carregar o conteúdo. Verifique sua conexão com a internet e tente novamente.",
  "iframe.error.title": "Falha na conexão",
  "intention.anonymous-praying": "Anônimo",
  "intention.answer.uplift": "Responda a esta mensagem de apoio",
  "intention.arrival.just-joined": "{userName} acabou de se juntar ao Hozana",
  "intention.arrival.welcome-pray": "Deseje as boas-vindas com uma oração!",
  "intention.birthday.celebration": "{username} está comemorando seu aniversário de {years}!",
  "intention.birthday.pray": "Deseje-lhe feliz aniversário em oração!",
  "intention.birthday.years-old": "{age, plural, one {{age} ano} other {{age} anos}}",
  "intention.created.description": "Será proposta aos membros da comunidade por 48 horas.",
  "intention.created.success": "Sua intenção foi depositada",
  "intention.delete.confirm-message1": "Tem certeza de que deseja excluir a intenção exibida atualmente?",
  "intention.delete.confirm-message2": "Os outros inscritos não poderão mais rezar pela sua intenção, e você não poderá agradecer aqueles que já rezaram por sua intenção.",
  "intention.delete.delete": "Excluir minha intenção",
  "intention.finished.arrival": "{count, plural, =0 {Ninguém} one {{count} pessoa} other {{count} pessoas}} orou para dar-lhe as boas-vindas no Hozana!",
  "intention.finished.birthday": "{birthdayDate}, {count, plural, =0 {ninguém} one {{count} pessoa} other {{count} pessoas}} orou para lhe desejar um feliz aniversário!",
  "intention.finished.intention": "O tempo de sua intenção expirou. {count, plural, =0 {Ninguém orou por você} one {Uma pessoa orou por você} other {{count} pessoas oraram por você}}. <link>Ver minha intenção</link>",
  "intention.finished.prayers": "{count, plural, =0 {Ninguém} one {{count} rezou} other {{count} pessoas rezaram}} {type, select, arrival {para desejar as boas-vindas no Hozana} birthday {por você no dia do seu aniversário} other {por sua intenção} }{count, plural, =0 {.} one {, gostaria de agradecer?} other {, gostaria de agradecê-los?}}",
  "intention.finished.thank": "Agradeço pelas orações",
  "intention.from": "Intention de {contactName}",
  "intention.invitation-to-pray-for": "{name} gostaria que você rezasse por sua intenção",
  "intention.load.error": "Ocorreu um erro. Não foi possível carregar a intenção.",
  "intention.not-found": "Intenção não encontrada",
  "intention.page.button": "Enviar uma intenção",
  "intention.pray-for": "Rezar por intenções de oração",
  "intention.prayed.already": "Você orou por essa intenção.",
  "intention.prayed.already-with": "Você{count, plural, =0 {} one { e uma outra pessoas} other { e # outras pessoas} } rezaram por esta intenção. Nós agradecemos!",
  "intention.prayed.birthday": "Você{count, plural, =0 {} one { e mais uma pessoa} other { e # pessoas}} oraram por {userName}",
  "intention.prayed.by": "{count, plural, =0 {Ninguém ainda orou} =1 {{name} já orou} =2 {{otherNames} e {name} já oraram} =3 {{otherNames} e {name} já oraram} =4 {{otherNames}, {name} e outra pessoa já oraram} other {{otherNames}, {name} e {remainingCount} outras pessoas já oraram}} por esta intenção",
  "intention.prayed.pray-for-others": "👉🏻 Gostaria de rezar por outras intenções?",
  "intention.prayed.thanks": "Obrigado!",
  "intention.prayed.with": "🙏 {count} {count, plural, one {pessoa orou} few {pessoas oraram} many {pessoas oraram} other {pessoas oraram}} junto com você por esta intenção",
  "intention.prayer.not-found": "Este usuário não parece ter orado por você",
  "intention.prayer.watchman.activate-notifications": "Para poder receber a notificação, você precisa ativá-la.",
  "intention.prayer.watchman.became-watchman": "Você é uma Sentinela da Oração!",
  "intention.prayer.watchman.become": "Torne-se uma Sentinela da Oração",
  "intention.prayer.watchman.commitment": "Você se comprometeu a receber e orar 3 intenções todos os dias",
  "intention.prayer.watchman.engagement.1": "Se tornando <strong>Sentinela da Oração</strong> :",
  "intention.prayer.watchman.engagement.2": "3 intenções todos os dias",
  "intention.prayer.watchman.engagement.3": "serão confiadas às suas orações",
  "intention.prayer.watchman.fetching": "Estamos recuperando as 3 intenções que você confiou para hoje",
  "intention.prayer.watchman.join": "Torne-se uma Sentinela da Oração",
  "intention.prayer.watchman.many-watchmen": "🙏 Já <strong>103 456</strong> pessoas engajadas!",
  "intention.prayer.watchman.method-reminder": "Como você gostaria de receber seu lembrete diário de oração?",
  "intention.prayer.watchman.pray-support": "Sostém seus irmãos e irmãs com suas orações",
  "intention.prayer.watchman.reminder.by-email": "Por e-mail",
  "intention.prayer.watchman.reminder.by-notification": "Por notificação",
  "intention.prayer.watchman.resign": "Eu quero parar",
  "intention.prayer.watchman.stop": "Pare meu compromisso",
  "intention.prayers.list.title": "Eles oraram por você",
  "intention.publish.button": "Confiar minha intenção",
  "intention.reload": "Veja outras intenções",
  "intention.share": "Compartilhe esta intenção",
  "intention.time-left": "{count}h",
  "intention.title": "Confie suas intenções, ore pelas dos outros",
  "intention.watchman.arrival.just-joined": "Você reza por {userName} que acabou de chegar em Hozana",
  "intention.write.here": "Escreva aqui sua intenção de oração",
  "intentions.not-found": "Não encontramos intenções para exibir",
  "intentions.title": "Deposite uma intenção no Hozana!",
  "intentions.view": "Ver as intenções",
  "introduction.forbidden-content": "O texto da introdução é inválido",
  "introduction.too-long": "O texto de introdução é muito longo",
  "introduction.too-short": "O texto de introdução é muito curto",
  "joinCommunity.community.join.already-finished-community": "Esta comunidade acabou",
  "journey.discover.current": "Ver os percursos de oração do momento",
  "journey.empty.active": "Você não tem nenhum percurso em andamento.",
  "journey.none.now": "Nenhum percurso de oração no momento",
  "journey.novenas-and-journeys": "Novenas e retiros",
  "journey.once.subscribed": "Assim que se inscrever numa novena ou num percurso de oração, irá encontrá-lo aqui",
  "journey.prayed.today": "Rezei hoje",
  "journey.see-history": "Histórico",
  "lang.unsupported": "O idioma que você solicitou não é compatível no momento",
  "language.en": "Inglês",
  "language.es": "Espanhol",
  "language.fr": "Francês",
  "language.it": "Itália",
  "language.pl": "Polonês",
  "language.pt": "Português",
  "leave.confirm.message": "Sua conta foi excluída com sucesso",
  "leave.guides-title": "Conheça nossos guias temáticos",
  "leave.pray-differently": "Você gostaria de orar de forma diferente?",
  "leave.sign-up-again": "👋🏻 Teremos o maior prazer em recebê-lo novamente se desejar continuar orando conosco",
  "login.account.disabled": "Sua conta foi desativada",
  "login.account.missing": "Nenhuma conta com este endereço de e-mail foi encontrada",
  "login.code-input.check-email": "Por favor, verifique o código recebido por e-mail",
  "login.code.required": "Código obrigatório",
  "login.csrf.invalid": "A sua sessão expirou, tente novamente",
  "login.email.invalid": "Endereço de email inválido",
  "login.email.not-provided": "Por favor, indique o seu endereço de e-mail",
  "login.email.required": "Email obrigatório",
  "login.failed": "O código é inválido ou expirou",
  "login.password.required": "Senha",
  "meeting.organizer.place.name-placeholder": "Igreja São Pedro",
  "meeting.organizer.time-invalid": "Escreva o horário do evento no formato HH:MM",
  "meeting.organizer.timeStart-invalid": "A hora de início deve ser menor que a hora de término",
  "message.automatic-message": "Mensagem automática",
  "message.delete": "Exclua a mensagem",
  "message.delete.user.not_allowed": "Oh! Você não pode deletar esta mensagem",
  "message.deleted": "Mensagem excluída",
  "message.from": "Mensagem de {contactName}",
  "message.godfather.welcome-message.to-godfather": "{contactName} acabou de entrar na Hozana graças ao seu convite. Seja bem-vindo!",
  "message.godfather.welcome-message.to-godson": "Você se inscreveu no Hozana graças ao convite de {contactName}. Desejamos boas-vindas!",
  "message.godfather.welcome-title.to-godfather": "Aqui estou eu",
  "message.godfather.welcome-title.to-godson": "Bem-vindo a Hozana!",
  "message.invalid": "Mensagem inválida",
  "message.list.title": "Mensagem",
  "message.list.title.conversation": "Para iniciar uma conversa com um membro do Hozana, comece rezando na página das Intenções.",
  "message.list.title.cta": "Eu rezo por uma intenção",
  "message.list.title.intention": "A pessoa por quem você rezou poderá agradecê-lo e iniciar uma conversa com você.",
  "message.prayer-on-arrival.has-thanked-you": "{contactName} agradece pela sua oração de boas-vindas no Hozana.",
  "message.prayer-on-arrival.you-thanked-for": "Você agradeceu a {contactName} por ter rezado desejando as boas-vindas no Hozana.",
  "message.prayer-on-birthday.has-thanked-you": "{contactName} agradece por sua oração em seu aniversário.",
  "message.prayer-on-birthday.you-thanked-for": "Você agradeceu a {contactName} por orar por você em seu aniversário.",
  "message.prayer-on-comment.has-prayed-for-you": "{contactName} orou por você a partir do comentário",
  "message.prayer-on-comment.you-prayed-for": "Você orou por {contactName} a partir do comentário",
  "message.prayer-on-intention.thank-you": "Você agradeceu ao {contactName} por orar pela sua intenção",
  "message.prayer-on-intention.thanked-you": "{contactName} agradece por rezar pela intenção dele",
  "message.prayer.has-just-prayed-for-you.short-multiple": "{count} pessoas oraram por você!",
  "message.prayer.has-just-prayed-for-you.short-single": "{contactName, select, _ {Alguém} other {{contactName}}} acabou de orar por você!",
  "message.prayer.has-prayed-for-you.long": "{contactName} rezou por sua intenção",
  "message.prayer.you-prayed-for.long": "Você orou por {contactName}",
  "message.reported": "Esta mensagem foi denunciada e a conversa foi bloqueada. Agradecemos por sua ajuda!",
  "message.suspicious.received": "Seu contato lhe enviou um link para clicar, um número para ligar ou ofereceu um local de encontro. Certifique-se de estar confiante com essa pessoa antes de continuar suas trocas.",
  "message.suspicious.sent": "Parece que você compartilhou seu número de telefone, e-mail ou link. Recomendamos que você tenha confiança na pessoa antes de continuar as trocas em outra plataforma menos segura.",
  "message.textarea.help.return": "Teclas Shift + Enter para retornar à linha",
  "message.unselected": "Nenhuma conversa selecionada",
  "message.update.user.not_allowed": "Oh! Você não pode editar esta mensagem",
  "missing.parameters": "Ops! Alguns parâmetros estão faltando para enviar uma mensagem de apoio.",
  "name.exists": "Este nome já foi dado a outra publicação",
  "name.forbidden-content": "Este nome não é válido",
  "name.invalid": "Nome inválido",
  "name.required": "Escreva o seu nome",
  "name.too-long": "Este nome é muito longo. Por favor, use apenas letras ou números",
  "name.too-short": "Este nome é muito curto. Por favor, use apenas letras ou números",
  "native.push.how-to.reactivate.description": "Ao clicar em \"Sim, ativar as notificações\", vamos encaminhá-lo para as definições do seu iPhone. Basta ativar a opção \"Notificações\" e tocar na seta para trás ⬅️ na parte superior para voltar.",
  "navigation.confession-link": "Confessar-se",
  "navigation.guides.title": "Nossos guias",
  "navigation.intentions": "Envie uma intenção",
  "navigation.live-page-link": "Missas e oração ao vivo",
  "navigation.search": "Procurar no Hozana",
  "notificationEmail.invalid": "O endereço de e-mail para receber notificações é inválido.",
  "oldPassword.invalid": "A senha atual não corresponde à indicada.",
  "page.gone": "Esta página não existe mais",
  "page.not-found": "Página não encontrada",
  "password.required": "Senha requerida",
  "password.too-long": "A senha é muito longa",
  "payload.bad-content": "O conteúdo é inválido",
  "payload.text-too-long": "Hmmm! Sua mensagem é muito longa",
  "pictureFileId.required": "Inserir imagem",
  "postIntention.content.too-long": "O conteúdo da intenção é muito longo",
  "pray.amen": "Amém!",
  "pray.comment.title": "Está orando por {userName}",
  "pray.entrust-intention": "Confie uma intenção {buttonText}",
  "pray.entrust-intention.body": "Outros orantes de Hozana rezarão por sua intenção.",
  "pray.i-pray.short": "Eu oro",
  "pray.intention.arrival.title": "Você está rezando por {userName} que acabou de chegar ao Hozana",
  "pray.intention.birthday.title": "É o aniversário de {userName}!",
  "pray.intention.community.show": "Reze pela intenção de {user}, que também está {lifetime, select, retreat {inscrito(a) neste retiro} novena {inscrito(a) nesta novena} other {membro desta comunidade}}",
  "pray.intention.publication.done": "Intenção confiada por {user}",
  "pray.intention.publication.show": "{user} também participa de \"{community}\", você quer rezar por sua intenção?",
  "pray.intention.show": "E agora, você quer orar pela intenção de {user}?",
  "pray.intention.title": "Você está rezando pela intenção de {userName}",
  "pray.pray": "Orar",
  "pray.pray-today": "Rezar hoje",
  "pray.prayed": "Eu rezei",
  "pray.prayer-sent": "Sua intenção de oração foi enviada",
  "pray.uplift.description": "Somente {userName} verá esta mensagem",
  "pray.uplift.sent": "Sua mensagem de apoio foi enviada",
  "pray.uplift.title": "Gostaria de deixar uma mensagem de apoio a {userName}?",
  "pray.write-intention": "Você também quer deixar uma intenção de oração?",
  "pray.your-intention": "Sua intenção de oração",
  "prayer-space.discover": "Isso pode interessar-lhe",
  "prayer-space.everlasting.load.error": "Um erro ocorreu ao carregar a seção \"No dia a dia\"",
  "prayer-space.journey.load.error": "Um erro ocorreu ao carregar a seção \"Novenas e retiros\"",
  "prayer-space.onboarding.step-1.description": "Toda a equipe da Hozana tem a alegria de apresentar este novo Espaço de Oração, que ajudará você a crescer na fidelidade à sua oração diária.",
  "prayer-space.onboarding.step-1.title": "Novo Espaço de Oração!",
  "prayer-space.onboarding.step-2.description": "Encontre facilmente as novenas e os retiros que você acompanha no momento e veja o seu progresso!",
  "prayer-space.onboarding.step-2.title": "Acompanhe suas Novenas e Retiros",
  "prayer-space.onboarding.step-3.description": "Encontre suas orações diárias na seção «No dia a dia»: o Evangelho do dia, a Liturgia das Horas, orações com o santo do dia e muito mais.",
  "prayer-space.onboarding.step-3.title": "Encontre suas orações diárias",
  "prayer-space.onboarding.step-4.description": "Na seção «Isso pode interessar a você», descubra as sugestões do momento e volte a rezar as novenas e os retiros de que você gostou.",
  "prayer-space.onboarding.step-4.title": "Descubra a riqueza da oração na Hozana",
  "prayer-space.welcome.discover": "Todas as nossas propostas",
  "prayer-space.welcome.end-paragraph": "Se essas sugestões não forem o que você está procurando, dê uma olhada em todo o nosso conteúdo. Tenho certeza de que você encontrará uma novena, um retiro ou uma comunidade permanente que lhe atenda.",
  "prayer-space.welcome.paragraph": "<strong>Olá {userName},</strong>\nDesejamos as boas-vindas no seu<strong>espaço de oração</strong> 🙏🏻 !\nÉ aqui que você encontrará as orações que serão propostas para você.\n👉🏻 Para receber as orações, <strong>você pode se inscrever agora mesmo em um itinerário de oração</strong>",
  "prayer.start": "Comece a rezar",
  "prayerContent.invalid": "A descrição da oração é inválida ou está vazia",
  "prayerContent.too-long": "O conteúdo de oração da sua comunidade é muito longo",
  "prayerName.invalid": "O título da oração é inválido ou está vazio",
  "prayerName.required": "Por favor, nomeie sua oração comunitária",
  "prayerName.too-long": "O nome da oração da sua comunidade é muito longo",
  "prayerSample.not-found": "Ops! Você não pode escolher esta oração",
  "publication.already-exists": "Já existe na sua comunidade uma publicação com o mesmo nome",
  "publication.comment.loadmore": "Carregar mais comentários",
  "publication.comment.loadmoreanswers": "Carregar mais respostas",
  "publication.comment.show": "Mostrar os comentários",
  "publication.comment.title": "{count} {count, plural, one {Comentário} other {Comentários}}",
  "publication.day": "Dia {day}",
  "publication.favorite.add": "Salvar como favoritos",
  "publication.favorite.how-to": "Você pode salvar uma postagem clicando no botão de opções de postagem",
  "publication.favorite.none.now": "Nenhuma postagem favorita",
  "publication.favorite.remove": "Não salvar",
  "publication.favorite.removed": "A postagem foi removida dos seus favoritos",
  "publication.favorite.success": "A postagem foi adicionada aos seus favoritos",
  "publication.frequency.type.daily": "Cada dia",
  "publication.frequency.type.long.daily": "Uma oração todos os dias",
  "publication.frequency.type.long.monthly": "Uma oração {value, plural, one {uma vez} other {# vez}} por mês",
  "publication.frequency.type.long.sporadically": "Uma oração de vez em quando",
  "publication.frequency.type.long.weekly": "Uma oração cada {value}",
  "publication.frequency.type.monthly": "{value, plural, one {Uma vez} other {# vez}} por mês",
  "publication.frequency.type.sporadically": "De vez em quando",
  "publication.frequency.type.weekly": "Cada {value}",
  "publication.goto": "Ver a comunidade",
  "publication.load.error": "Ocorreu um erro. Não foi possível carregar a publicação.",
  "publication.not-found": "Esta publicação não foi encontrada",
  "publication.prayed": "🙏 {count} {count, plural, one {pessoa orou} other {pessoas oraram}} com você",
  "publication.prayed-by": "{count, plural, =0 {Você orou por esta publicação} =1 {Você e uma outra pessoa rezaram com essa publicação} other {Você e {count} outras pessoas oraram por esta publicação}}",
  "publication.prayed-by.short": "{count, plural, =0 {Você rezar} =1 {Você e outra pessoa oraram} other {Você e {count} outras pessoas oraram}}",
  "publication.prayed.share.body": "Compartilhe a publicação ou a comunidade 😇",
  "publication.prayed.share.button": "Eu compartilho com um amigo",
  "publication.prayed.share.choose.body": "Ao compartilhar conteúdo de oração, você pode<strong> transformar profundamente a vida de alguém! 😇 </strong>",
  "publication.prayed.share.choose.title": "O que você quer compartilhar?",
  "publication.prayed.share.community.button": "Eu compartilho a comunidade",
  "publication.prayed.share.community.modal.title": "Compartilhe esta comunidade",
  "publication.prayed.share.publication.button": "Eu compartilho a publicação",
  "publication.prayed.share.publication.modal.title": "Compartilhe esta publicação",
  "publication.prayed.share.title": "Você conhece alguém que poderia ser tocado pela oração que você acabou de ler?",
  "publication.update": "Editar a publicação",
  "publicationFrequencyType.required": "Por favor, indique a frequência de publicação",
  "publicationFrequencyValue.invalid": "A frequência de publicação escolhida não é válida",
  "publicationFrequencyValue.required": "Insira uma frequência de publicação",
  "push.activated": "As notificações foram ativadas com sucesso",
  "push.allow.message": "Aceite a solicitação do seu navegador para ativar as notificações.",
  "push.blocked.how-to.reactivate": "Como reativar as notificações?",
  "push.blocked.how-to.settings.allow": "autorize <i>hozana.org</i> a enviar notificações.",
  "push.blocked.how-to.settings.find-hozana": "na lista de sites, encontre <i>hozana.org</i>,",
  "push.blocked.how-to.settings.find-list": "encontre as permissões concedidas aos sites ou as configurações de notificação,",
  "push.blocked.how-to.settings.icon": "Se você não localizar esse ícone, precisará acessar as configurações do navegador:",
  "push.blocked.how-to.url-icon.allow": "você só precisará suspender a proibição de enviar notificações.",
  "push.blocked.how-to.url-icon.browser": "Em muitos navegadores, você encontrará um ícone em formato de cadeado na barra de endereço do site: na esquerda ou na direita de <i>hozana.org/communaute/...</i>",
  "push.blocked.how-to.url-icon.click": "clique neste ícone e encontre a opção \"notificações\",",
  "push.blocked.message": "Você desativou as notificações neste dispositivo. Por favor, reative-as se desejar receber notificações de Hozana.",
  "push.blocked.support-link": "Visite a ajuda dedicada ao {browser} para obter mais detalhes em caso de problemas",
  "push.blocked.title": "Notificações bloqueadas",
  "reportAbuse.reason.required": "Você deve especificar o motivo do seu relatório",
  "reportAbuse.type.invalid": "Ops! Erro técnico: seu relatório não foi enviado",
  "resetPassword.token.invalid": "Ocorreu um erro: tente novamente clicando novamente em \"Esqueceu sua senha?\"",
  "role.invalid": "Esse papel não pode ser aceito",
  "rosario.bloc.cta": "Eu rezo o rosário em Rosário",
  "rosario.bloc.description.1": "1 – Forme um grupo de oração de 5 pessoas",
  "rosario.bloc.description.2": "2 – Todos os dias, todos recebem um mistério do rosário e levam 5 minutos do dia para meditar sobre ele, recitando cerca de dez",
  "rosario.bloc.description.3": "3 – No final do dia, o grupo terá meditado sobre os 5 mistérios do dia, completando assim um terço inteiro: este é o terço vivo!",
  "rosario.bloc.title": "Descubra a 1ª aplicação do terço vivo!",
  "rosario.xmrpms.cta": "Participar no presente",
  "rosario.xmrpms.description": "Em maio, mês de Maria, <strong>cada dezena</strong> rezada no Rosário é <strong>uma rosa</strong> oferecida a ela!",
  "rosario.xmrpms.objective": "Objetivo: <strong>5 milhões de rosas até 31 de maio.</strong>",
  "rosario.xmrpms.title": "Junte-se a um GRANDE presente para Maria",
  "scheduledTime.invalid": "A data de agendamento de publicação não é válida",
  "score-threshold-not-met": "A pontuação de verificação não foi atingida. Por favor, conclua a verificação.",
  "sendMessage.payload.bad-content": "Hmmm! Você não pode enviar o conteúdo desta mensagem",
  "settings.account.birthdate": "Data de nascimento",
  "settings.account.confirm-password": "Confirme sua nova senha",
  "settings.account.current-password": "Sua senha antiga",
  "settings.account.delete": "Excluir conta",
  "settings.account.delete.confirm": "Você está prestes a deletar sua conta Hozana. Esta ação é irreversível.\n\nPara confirmar a exclusão definitiva da sua conta, digite a palavra <strong>DELETAR</strong> (em letras maiúsculas) no campo abaixo e depois confirme.",
  "settings.account.delete.error-input": "Você deve escrever DELETAR aqui",
  "settings.account.delete.input": "Escreva DELETAR aqui",
  "settings.account.new-password": "Sua nova senha",
  "settings.card.community.announce": "Receba os anúncios",
  "settings.card.community.announce.details": "Para permitir que os animadores da comunidade lhe enviem uma mensagem",
  "settings.card.community.prayer": "Receba cada oração",
  "settings.card.notifs.email": "Por e-mail",
  "settings.card.notifs.push": "Por notificação",
  "settings.email.disable.all": "Ative e-mails para todas as configurações",
  "settings.header.notifications": "E-mails e notificações",
  "settings.header.title.community": "Configurações da comunidade",
  "settings.input.email-is-not-valid": "Forneça um endereço de e-mail válido",
  "settings.input.name-is-not-email": "Basta inserir o seu nome",
  "settings.input.password.label": "Senha da sua conta",
  "settings.input.password.social-connect": "Você está conectado por uma conta {socialName}. Para conectar por senha é preciso definir uma.",
  "settings.input.title.placeholder": "Sr., Sra., Padre, Irmã ...",
  "settings.language.title": "Idioma da sua conta",
  "settings.notifications.community-registration.title": "Você está se inscrevendo em uma comunidade, novena ou retiro",
  "settings.notifications.disable.all": "Ative notificações para todas as configurações",
  "settings.notifications.end-of-novena.title": "Sua retiro está terminando",
  "settings.notifications.general.description": "Emails e notificações de intenções e outros recursos",
  "settings.notifications.general.title": "Notificações gerais",
  "settings.notifications.incriptions.description": "Emails e notificações de novenas, jornadas e conteúdos diários",
  "settings.notifications.incriptions.title": "Notificações relacionadas às minhas inscrições",
  "settings.notifications.intention-end-time.title": "Fim da exibição da sua intenção de oração",
  "settings.notifications.invited-join.title": "Alguém se inscreveu no Hozana graças a você",
  "settings.notifications.message.title": "Nova mensagem",
  "settings.notifications.newsletter.title": "Boletim informativo Hozana",
  "settings.notifications.no-ongoing-community.title": "Lembrete para entrar em um retiro",
  "settings.notifications.pray-remind.title": "Lembrete diário de oração",
  "settings.notifications.watchman-remind.title": "Lembrete Sentinela da oração",
  "settings.notifications.watchman.description": "Configurações e lembretes",
  "settings.notifications.watchman.title": "Você é um Vigilante de Oração",
  "settings.profile-and-settings": "Perfil e configurações",
  "settings.unsubscribe-presubscriber.error": "Ocorreu um erro durante a inscrição",
  "settings.unsubscribe-presubscriber.success": "Você não foi assinado",
  "share.community": "Compartilhar {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidade}}",
  "share.community.share": "Compartilhe {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidade}}",
  "share.copied-link": "Link copiado",
  "share.copy-link": "Copiar o link",
  "share.intention.email-body": "Convido você a rezar por esta intenção: {intentionUrl}.",
  "share.intention.share": "Compartilhar esta intenção",
  "share.my.intention.email-body": "Convido você a rezar pela minha intenção: {intentionUrl}.",
  "share.publication.email-body": "Convido você a conhecer esta publicação “{publicationName}” no Hozana: {publicationUrl}.",
  "share.share": "Compartilhar",
  "share.share-by-email": "Convidar por e-mail",
  "share.share-by-email-body": "Convido você a conhecer {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidade}} no Hozana « {communityName} » : {url}.",
  "share.wording.send-email": "Enviar um email",
  "share.wording.share-on-whatsapp": "Compartilhar pelo Whatsapp",
  "signup.captcha.required": "Por favor, clique em \"Eu não sou um robô\"",
  "signup.code.invalid": "O código é inválido ou expirou",
  "signup.email.exists": "Já existe uma conta com este endereço de email",
  "signup.email.invalid": "Endereço de e-mail inválido",
  "signup.email.required": "Endereço de e-mail",
  "signup.fail": "Ocorreu um erro na criação da sua conta",
  "signup.name.invalid": "Ocorreu um erro por causa do seu primeiro nome",
  "signup.name.required": "Necessário colocar um nome",
  "signup.password.required": "Necessário colocar uma senha",
  "startConversation.payload.bad-content": "Hmmm! Você não pode enviar o conteúdo desta mensagem",
  "startConversation.user.not-found": "Hmmm! Sua mensagem não deve exceder 10.000 caracteres",
  "tab.discover": "Descobrir",
  "tab.error.generic-description": "Esta aba encontrou um erro.",
  "tab.error.try-again": "Repetir",
  "tab.messaging": "Mensagens",
  "tab.prayer-space": "Espaço de oração",
  "tag.not-found": "Tag não encontrada",
  "thanks.prayed.watchman.intentions": "Obrigado pela sua lealdade",
  "timeout-or-duplicate": "O Captcha expirou ou já foi usado. Por favor, verifique novamente.",
  "token.expired": "O token, ou chave de autenticação, expirou. Verifique se você utilizou o link, enviado nas últimas 48 horas, para alterar sua senha.",
  "token.required": "Por favor, inserir o token",
  "uplift.answer.error": "Ocorreu um erro. Sua resposta não foi enviada.",
  "uplift.message": "Mensagem de apoio",
  "uplift.message.error": "Ocorreu um erro. Sua mensagem de apoio não foi enviada.",
  "uplift.textarea.placeholder.long": "Deixe uma mensagem de apoio a {userName}...",
  "uplift.textarea.placeholder.short": "Digite sua mensagem de apoio...",
  "user.avatar.logo": "Meu logo",
  "user.communities": "Este usuário propõe",
  "user.communities.other": "Ver todas as propostas",
  "user.delivery-issue-email.alert-message": "Parece haver um problema com o seu endereço de e-mail",
  "user.delivery-issue-email.hard-bounce-invalid": "<p>Parece haver um problema com o seu endereço de e-mail. Não estamos conseguindo enviar os e-mails que você deseja receber da Hozana 😅</p> <p>Por favor, verifique o seu endereço de e-mail.</p>",
  "user.delivery-issue-email.spam-report": "<p>Parece que o seu endereço de e-mail está classificando nossas mensagens como \"Spam\" ou \"Correio indesejado\" 😞</p> <p>Recomendamos que você:<br/> • acesse sua pasta de spam e mova os e-mails mais recentes da Hozana para a sua caixa de entrada,<br/> • depois, adicione \"ola@hozana.org\" à sua lista de contatos (ou remetentes confiáveis).</p> <p>Se o problema continuar após 3 dias, por favor, clique no botão \"Reportar um problema\" abaixo.</p>",
  "user.delivery-issue-email.verify-email": "Verificarei meu e-mail",
  "user.happy-birthday.psalm": "Porque tu formaste o meu interior; tu me teceste no ventre de minha mãe. Eu te louvarei, porque de um modo assombroso e tão maravilhoso fui feito […]",
  "user.happy-birthday.reference": "Salmo 139:13-14",
  "user.happy-birthday.title": "Feliz aniversário,\n{username}!",
  "user.happy-birthday.users-pray-for-you": "Hoje, usuários estão orando por você!",
  "user.happy-birthday.wish": "Feliz aniversário!",
  "user.home-location": "Em que cidade você mora?",
  "user.logout.word": "Desconectar",
  "user.mail.unsubscribe": "Você não receberá mais e-mails nossos solicitando doações por um ano.",
  "user.not-found": "Esse usuário não existe",
  "user.popins.avatars.choose-my-image": "Escolher minha foto de perfil",
  "user.profile.done-communities": "As minhas listagens terminou",
  "user.profile.favorite-publications": "Publicações favoritas",
  "user.profile.my-profile": "Meu perfil",
  "user.profile.questions.title.wizard": "E finalmente,\npara atendê-lo melhor",
  "user.profile.questions.you-are": "Você é",
  "user.profile.questions.your-birthdate": "Para orar por você no seu aniversário, você nasceu em",
  "user.profile.questions.your-location": "Sua cidade",
  "user.settings.click-to-fill": "Clique para preencher",
  "user.settings.tab.account.password-required": "Por favor, digite sua senha para validação.",
  "user.title.brother": "Irmão",
  "user.title.deacon": "Diácono",
  "user.title.family": "Família",
  "user.title.father": "Padre",
  "user.title.miss": "Srta",
  "user.title.mr": "M.",
  "user.title.mrs": "Sra",
  "user.title.org": "Organização",
  "user.title.sister": "Irmã",
  "user.wizard.audio": "Áudio",
  "user.wizard.complete": "Estamos procurando\no que você pode gostar...",
  "user.wizard.minutes": "min",
  "user.wizard.my-wizard": "Minhas preferências de oração",
  "user.wizard.novena": "Novena",
  "user.wizard.reading": "Leitura",
  "user.wizard.video": "Vídeo",
  "user.wizard.welcome.user": "Bem-vindo {name}!",
  "user.wizard.what-themes": "Quais temas lhe interessam?",
  "user.wizard.what-topics": "Você tem um assunto que esteja tocando o seu coração agora?",
  "watchman.daily-counted.intentions": "{count, plural, one {A sua intenção do dia} other {As suas {count} intenções do dia}}",
  "watchman.daily.close": "Deseja parar de rezar?",
  "watchman.daily.continue": "Continuar rezando",
  "watchman.daily.intentions": "As suas intenções do dia",
  "watchman.daily.pray-for-more": "Rezar por mais intenções",
  "watchman.daily.remaining": "{count, plural, one {Resta {count} intenção} other {Restam {count} intenções}} para hoje",
  "watchman.intentions.choice": "Escolha das intenções",
  "watchman.intentions.explanation": "As intenções são escolhidas aleatoriamente entre aqueles que receberam menos de 20 orações",
  "watchman.intentions.explanation.end": "Você pode editar cada uma das intenções ao seu gosto, clicando no ícone 🔄 ao lado de cada intenção.",
  "watchman.pray-for-today": "Rezar por hoje",
  "watchman.prayers.thank-you": "Obrigado pelas orações",
  "watchman.prayers.thanks-for": "Obrigado por {name}",
  "watchman.push.description": "<strong>Ative as notificações</strong> para acompanhar melhor o seu compromisso como Sentinela de oração.",
  "watchman.push.details": "Você poderá alterar suas configurações a qualquer momento.",
  "watchman.push.title": "Permaneça fiel,<br/>receba um lembrete!",
  "watchman.rely.remains": "{count, plural, one {Uma pessoa ainda conta com a sua oração} other {{count} pessoas ainda contam com as suas orações}}",
  "watchman.three.intentions": "Ore por 3 intenções a cada dia",
  "widget.not-found": "O widget de \"intenção\" não foi encontrado",
  "wizard.communityFormats.unknown": "Ops! pequeno problema, a seleção não funcionou",
  "wizard.communityTypes.unknown": "Ops! pequeno problema, a seleção não funcionou",
  "wizard.prayerDuration.unknown": "Ops! pequeno problema, a seleção não funcionou",
  "wizard.tags.unknown": "Ops! pequeno problema, a seleção não funcionou",
  "word.all.feminine": "Todas",
  "word.cancel": "Cancelar",
  "word.characters": "{count, plural, =0 {Não há mais caracteres restantes} one {1 caractere restante} other {{count} caracteres restantes}}",
  "word.choose": "Selecionar",
  "word.close": "Fechar",
  "word.confirm": "Confirmar",
  "word.congratulations": "Parabéns!",
  "word.continue": "Continuar",
  "word.create.content": "Crie conteúdo",
  "word.days": "{count, plural, one {# dia} other {# dias}}",
  "word.edit": "Editar",
  "word.email": "Email",
  "word.email-address": "Endereço de e-mail",
  "word.email-address-connection": "Endereço de email de conexão",
  "word.email-address-notification": "Endereço de e -mail de notificação",
  "word.finish": "Terminar",
  "word.in": "em",
  "word.intentions": "Intenções",
  "word.leave-message": "Coloque",
  "word.next": "Seguinte",
  "word.no": "Não",
  "word.notifications": "Notificações",
  "word.notifications.mails": "Notificações e emails",
  "word.prayers": "Orações",
  "word.prayers-count": "{count, plural, one {{count} oração} other {{count} orações}}",
  "word.previous": "Anterior",
  "word.remove": "Excluir",
  "word.save": "Salvar",
  "word.send": "Enviar",
  "word.skip": "Pular",
  "word.start": "Começar",
  "word.start-again": "Recomeçar",
  "word.stop": "Parar",
  "word.thank-you": "Obrigado",
  "word.today": "Hoje",
  "word.validate": "Confirmar",
  "word.watchman": "Observador de Orações",
  "word.whats-next": "O que você deseja fazer agora?",
  "word.yes": "Sim",
  "word.yesterday": "Ontem",
  "word.you": "Você",
  "word.your-firstname": "Seu primeiro nome",
  "word.your-title": "Sua civilidade",
  "wording.i-share": "Eu compartilho",
  "words.a-man": "Um homem",
  "words.a-woman": "Uma mulher",
  "words.answer": "Responder",
  "words.by-user": "Por {userName}",
  "words.click-here": "Clique aqui",
  "words.contact-us": "Contate-Nos",
  "words.daily": "No dia a dia",
  "words.done": "Está feito",
  "words.has-prayed": "{contactName} rezou",
  "words.hello.user": "Olá {userName},",
  "words.home-page": "Página inicial",
  "words.i-check": "Vou verificar",
  "words.i-continue": "Eu continuo",
  "words.i-subscribe": "Quero fazer parte",
  "words.in-nb-days": "Em {nbDays} {nbDays, plural, one {dia} other {dias}}",
  "words.in-nb-days-begin": "Começa em {nbDays} {nbDays, plural, one {dia} other {dias}}",
  "words.know-more": "Saiba mais",
  "words.maybe-later": "Talvez mais tarde",
  "words.nb-days": "{nbDays} {nbDays, plural, one {dia} other {dias}}",
  "words.no-thanks": "Não, obrigado",
  "words.no-thanks2": "não, obrigado",
  "words.not-now": "Não agora",
  "words.ongoing": "Agora",
  "words.password.placeholder": "Sua senha",
  "words.profile": "Perfil",
  "words.see": "Ver",
  "words.see-all.plur-fem": "Ver todas",
  "words.see-all.sing": "Veja tudo",
  "words.sign-up": "Registrar",
  "words.terms-of-use": "Termos de uso",
  "words.thank": "Agradecer",
  "words.thank-you-very-much": "Muito obrigado ! 😊",
  "words.thanked": "Agradecido",
  "words.you-prayed": "Você rezou",
  "words.your-email-address": "Seu endereço de e-mail",
  "words.your-intention": "Sua intenção",
  "words.your-message": "Sua mensagem",
  "fraternity.download-app.benefit.content": "Acesso fácil ao conteúdo da Virtus",
  "fraternity.download-app.benefit.fraternity": "Mantenha contato com sua fraternidade",
  "fraternity.download-app.benefit.notifications": "Receba as informações certas na hora certa",
  "fraternity.download-app.cta": "Baixe o aplicativo",
  "fraternity.download-app.description": "Baixe o aplicativo Hozana para encontrar a Virtus facilmente todos os dias.",
  "fraternity.download-app.dismiss": "Não, obrigado",
  "fraternity.download-app.free": "Hozana é uma aplicação <strong>associativa</strong> e completamente <strong>gratuita</strong>.",
  "fraternity.download-app.title": "Virtus ao seu alcance"
}
